import { after } from 'aspect-ts';
import { logUser, send_messages } from 'logger';

import { do_logout, xapi_logout } from '../widgets/logout';

const idleResets = ['onmousemove', 'onkeydown', 'onclick', 'onscroll'];

export class IdleMonitor {
	private idle: boolean;
	private idlefor: number;
	private idletimer: any = null;
	private logouttimer: any = null;
	private _idletime: number;
	private _idlelogout: number;

	constructor() {
		this.idle = false;
		this.idlefor = 0;
		this._idletime = 120000;
		this._idlelogout = 600000;

		for (const reset of idleResets) {
			if ((document as any)[reset] === null) {
				(document as any)[reset] = () => this.onReset();
			} else {
				after(document, reset, () => {
					this.onReset();
				});
			}
		}
	}

	public get idletime(): number {
		return this._idletime / 1000;
	}

	public set idletime(value: number) {
		this._idletime = value * 1000;
	}

	public get idlelogout(): number {
		return this._idlelogout / 1000;
	}

	public set idlelogout(value: number) {
		this._idlelogout = value * 1000;
	}

	private onReset() {
		if (this.idle) {
			this.idle = false;
			logUser.info(() => 'active');
			this.logouttimer && clearTimeout(this.logouttimer);
			this.idletimer = setTimeout(() => this.setIdle(), this._idletime);
			this.logouttimer = setTimeout(() => this.doLogout(), this._idlelogout);
		} else {
			this.idletimer && clearTimeout(this.idletimer);
			this.logouttimer && clearTimeout(this.logouttimer);
			this.idletimer = setTimeout(() => this.setIdle(), this._idletime);
			this.logouttimer = setTimeout(() => this.doLogout(), this._idlelogout);
		}
	}

	private setIdle() {
		this.idle = true;
		logUser.info(() => `idle`);
	}

	private doLogout() {
		logUser.info(() => `idle for at least ${this.idlelogout} seconds -- logging out`);
		xapi_logout();
		send_messages().then(
			() => do_logout(),
			() => do_logout()
		);
	}
}
